import { Component } from '@angular/core';

@Component({
  selector: 'app-anonymous-payment-plan',
  templateUrl: './anonymous-payment-plan.component.html',
  styleUrls: ['./anonymous-payment-plan.component.scss'],
})
export class AnonymousPaymentPlanComponent {}
